import React, { useMemo } from "react";
import { Card, Typography, Button, Icon } from "@ann/web-components";
import {
  AssignRoleCardContainer,
  AssignRoleDescription,
  SelectedRolesGrid,
  SelectedRoleCardContent,
  SelectedRoleInfo,
  SelectedRoleActions,
  ViewDetailsLink,
} from "./AssignRoleCard.styled";

const AssignRoleCard = ({ onAssignRole, selectedRoles, onRemoveRole, rolesData = [] }) => {
  const hasSelections = Array.isArray(selectedRoles) && selectedRoles.length > 0;

  const selectedRoleDetails = useMemo(() => {
    if (!hasSelections) return [];

    // Create a map for quick lookup
    const rolesMap = new Map(rolesData.map((role) => [role.roleUuid, role]));

    return selectedRoles
      .map((roleId) => {
        const role = rolesMap.get(roleId);
        if (role) {
          return {
            id: role.roleUuid,
            title: role.name,
            description: role.description || "No description available.",
          };
        }
        // Show role with ID if data not available yet
        return {
          id: roleId,
          title: roleId,
          description: "Loading role details...",
        };
      });
  }, [hasSelections, selectedRoles, rolesData]);

  if (!hasSelections) {
    return (
      <Card size="medium">
        <AssignRoleCardContainer>
          <Typography category="title" size="small" weight="bold">
            No roles assigned yet
          </Typography>
          <AssignRoleDescription>
            Assign a role to set the right permissions for this user. Roles define what tools and features they can access.
          </AssignRoleDescription>
          <Button label="Assign a role" size="medium" iconRight="plus" onClick={onAssignRole} />
        </AssignRoleCardContainer>
      </Card>
    );
  }

  return (
    <SelectedRolesGrid>
      {selectedRoleDetails.map((role) => (
        <Card key={role.id} size="small" style={{ width: "100%", minHeight: "50px" }}>
          <SelectedRoleCardContent>
            <SelectedRoleInfo>
              <Typography category="title" size="small" weight="bold">
                {role.title}
              </Typography>
              <Typography category="body" size="small" weight="regular">
                {role.description}
              </Typography>
            </SelectedRoleInfo>
            <SelectedRoleActions>
              <ViewDetailsLink type="button">View details</ViewDetailsLink>
              <Icon name="close" onClick={() => onRemoveRole(role.id)} style={{ cursor: "pointer" }} />
            </SelectedRoleActions>
          </SelectedRoleCardContent>
        </Card>
      ))}
    </SelectedRolesGrid>
  );
};

export default AssignRoleCard;

